import React from "react";
import _ from "lodash";

import Table from "components/Table";
import { fustLinesColumns } from "./columns";

interface IProps {
  isLoading: boolean;
  loadData: () => void;
  data: any[];
}

class FustLines extends React.PureComponent<IProps> {
  public componentDidMount() {
    this.props.loadData();
  }

  public render() {
    const { data, isLoading } = this.props;

    return (
      <Table
        columns={fustLinesColumns}
        dataSource={data}
        isLoading={isLoading}
      />
    );
  }
}

export default FustLines;
